<script>
import ElPopover from 'element-ui/packages/popover/src/main'
import Popper from 'element-ui/src/utils/vue-popper'

// 浮层会移到 body；类必须加在 popper 本体，不能只加在触发器外层。
function addPopoverClass (vnode) {
  if (!vnode) return
  if (vnode.data && vnode.data.ref === 'popper') {
    const classes = vnode.data.class
    if (!Array.isArray(classes) || !classes.includes('ui-popover')) {
      vnode.data.class = [classes, 'ui-popover']
    }
    return
  }
  const children = (vnode.componentOptions ? vnode.componentOptions.children : vnode.children) || []
  children.forEach(addPopoverClass)
}

function isPopoverDestroying (vm) {
  return !vm || vm._uiPopoverDestroying || vm._isBeingDestroyed || vm._isDestroyed
}

function removeBodyPopover (vm) {
  const popper = vm && (vm.popperElm || (vm.$refs && vm.$refs.popper))
  if (!popper || typeof document === 'undefined' || popper.parentNode !== document.body) return

  // 路由或登录会话被快速替换时，兜底移除挂到 body 的旧浮层，避免重新登录后出现幽灵面板。
  popper.style.display = 'none'
  popper.setAttribute('aria-hidden', 'true')
  document.body.removeChild(popper)
}

export default {
  name: 'ElPopover',
  extends: ElPopover,
  beforeDestroy () {
    // Popper 创建后还会排队执行一次 updatePopper；销毁期间必须阻止它把旧节点重新挂回 body。
    this._uiPopoverDestroying = true
    removeBodyPopover(this)
  },
  destroyed () {
    removeBodyPopover(this)
  },
  methods: {
    createPopper () {
      if (isPopoverDestroying(this)) return
      return Popper.methods.createPopper.call(this)
    },
    updatePopper () {
      if (isPopoverDestroying(this)) return
      return Popper.methods.updatePopper.call(this)
    }
  },
  render (h) {
    const vnode = ElPopover.render.call(this, h)
    addPopoverClass(vnode)
    return vnode
  }
}
</script>
